import ArrayUtil from '../ArrayUtil';
import Vector from '../Math/Vector';
import Mesh from './Mesh';

export default class BoxMesh extends Mesh {

    constructor(renderer, w, h, d) {
        super(renderer, BoxMesh.CreateData(...ArrayUtil.slice(arguments, 1)));
    }

    /**
     * Computes the vertices and faces to create a box mesh.
     */
    static CreateData() {

        let xSize, ySize, zSize;

        // 
        switch (arguments.length) {

            default:
                throw new Error("Invalid parameter count.");

            // 
            case 1:
                xSize = arguments[0];
                ySize = arguments[0];
                zSize = arguments[0];
                break;

            // 
            case 3:
                [xSize, ySize, zSize] = arguments;
                break;
        }

        let scale = new Vector(xSize, ySize, zSize);

        let normals = [
            new Vector(+1, 0, 0),
            new Vector(-1, 0, 0),
            new Vector(0, +1, 0),
            new Vector(0, -1, 0),
            new Vector(0, 0, +1),
            new Vector(0, 0, -1),
        ];

        let vertices = [];
        let indices = [];

        // 
        normals.forEach((f, i) => {

            // Basis?!
            let s = normals[(i + 2) % normals.length];
            let u = f.cross(s);

            // 
            let f_ = f.mul(scale); // Forward
            let u_ = u.mul(scale); // Up
            let s_ = s.mul(scale); // Side

            // Computes the corners of the quad
            let q1 = f_.sub(s_).sub(u_);
            let q2 = f_.add(s_).sub(u_);
            let q3 = f_.add(s_).add(u_);
            let q4 = f_.sub(s_).add(u_);

            // Offset for constructing faces
            let offset = vertices.length;

            const nVector = [f.x, f.y, f.z];

            // Append vertices to mesh data
            vertices.push([q1.x, q1.y, q1.z].concat(nVector).concat([0, 0]));
            vertices.push([q2.x, q2.y, q2.z].concat(nVector).concat([1, 0]));
            vertices.push([q3.x, q3.y, q3.z].concat(nVector).concat([1, 1]));
            vertices.push([q4.x, q4.y, q4.z].concat(nVector).concat([0, 1]));

            // Construct faces
            indices.push(
                offset + 0, offset + 1, offset + 2,
                offset + 0, offset + 2, offset + 3
            );
        });

        // 
        return {
            vertices, indices,
            attributes: Mesh.standardVertexLayout
        };
    }
}